import dayjs from "dayjs";

let lastDisplayedDate = null;

const explorerGraph = {
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow",
    },
  },
  toolbox: {
    show: true,
    feature: {
      dataZoom: { yAxisIndex: "none" },
      restore: {},
      mark: { show: true },
      dataView: { show: true, readOnly: true },
      saveAsImage: { show: true, name: "device_insights" },
    },
  },
  grid: {
    left: 60,
    top: 50,
    right: 60,
    bottom: 110,
  },
  legend: {
    data: [],
    left: "center",
    icon: "roundRect",
  },
  xAxis: {
    type: "time",
    boundaryGap: false,
    name: "Time",
    nameGap: 40,
    nameLocation: "middle",
    axisPointer: {
      label: {
        formatter: function (params) {
          return dayjs(params.value).format("MM-DD-YYYY HH:mm:ss");
        },
      },
      handle: {
        show: false,
      },
    },
    axisLabel: {
      formatter: function (value) {
        const date = new Date(value);
        const formattedDate = `${(date.getMonth() + 1)
          .toString()
          .padStart(2, "0")}/${date
          .getDate()
          .toString()
          .padStart(2, "0")}/${date.getFullYear()}`;

        if (formattedDate === lastDisplayedDate) {
          return "";
        }
        lastDisplayedDate = formattedDate;
        return formattedDate;
      },
    },
  },
  yAxis: [],
  series: [],
  dataZoom: [
    { type: "inside", start: 0, end: 100 },
    { start: 0, end: 100 },
  ],
};

export default explorerGraph;
